import { render, staticRenderFns } from "./PageHero.vue?vue&type=template&id=1532a78f&scoped=true"
var script = {}
import style0 from "./PageHero.vue?vue&type=style&index=0&id=1532a78f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1532a78f",
  null
  
)

export default component.exports